import {NgModule} from '@angular/core';
import {SharedModule} from '../../../shared/shared.module';
import {Routes, RouterModule} from '@angular/router';
import {TourCenterLatLngPipe} from './pipes/tour-center-lat-lng.pipe';
import {TourStopMarkersPipe} from './pipes/tour-stop-markers.pipe';
import {
  DetailContentAccomodationTabsComponent
} from './components/detail-content-accomodation-tabs/detail-content-accomodation-tabs.component';
import {DetailContentAccomodationComponent} from './components/detail-content-accomodation/detail-content-accomodation.component';
import {DetailContentActivitiesComponent} from './components/detail-content-activities/detail-content-activities.component';
import {DetailContentAsideComponent} from './components/detail-content-aside/detail-content-aside.component';
import {DetailContentDescriptionComponent} from './components/detail-content-description/detail-content-description.component';
import {DetailContentFacilitiesComponent} from './components/detail-content-facilities/detail-content-facilities.component';
import {DetailContentItineraryComponent} from './components/detail-content-itinerary/detail-content-itinerary.component';
import {DetailContentLanguagesComponent} from './components/detail-content-languages/detail-content-languages.component';
import {DetailContentMapComponent} from './components/detail-content-map/detail-content-map.component';
import {DetailContentOffersComponent} from './components/detail-content-offers/detail-content-offers.component';
import {DetailContentTagsComponent} from './components/detail-content-tags/detail-content-tags.component';
import {DetailContentTermsComponent} from './components/detail-content-terms/detail-content-terms.component';
import {DetailContentTourTabsComponent} from './components/detail-content-tour-tabs/detail-content-tour-tabs.component';
import {DetailContentTourComponent} from './components/detail-content-tour/detail-content-tour.component';
import {DetailGalleryComponent} from './components/detail-gallery/detail-gallery.component';
import {DetailHeaderComponent} from './components/detail-header/detail-header.component';
import {DetailResumeComponent} from './components/detail-resume/detail-resume.component';
import {DetailSliderComponent} from './components/detail-slider/detail-slider.component';
import {HolidayDetailComponent} from './holiday-detail.component';
import {DetailFlightComponent} from './components/detail-flight/detail-flight.component';
import {DetailOccupancyComponent} from './components/detail-occupancy/detail-occupancy.component';
import {DetailPriceGridComponent} from './components/detail-price-grid/detail-price-grid.component';
import {HolidayDetailGenericPageComponent} from '../holiday-detail-generic-page/holiday-detail-generic-page.component';
import {
  HolidayDetailGenericPageSolutionsComponent
} from '../holiday-detail-generic-page/holiday-detail-generic-page-solutions/holiday-detail-generic-page-solutions.component';
import {
  HolidayDetailGenericPageSolutionCardComponent
} from '../holiday-detail-generic-page/holiday-detail-generic-page-solution-card/holiday-detail-generic-page-solution-card.component';
import {
  HolidayDetailGenericPageRecapComponent
} from '../holiday-detail-generic-page/holiday-detail-generic-page-recap/holiday-detail-generic-page-recap.component';
import {
  HolidayDetailgenericPageDateComponent
} from '../holiday-detail-generic-page/holiday-detailgeneric-page-date/holiday-detailgeneric-page-date.component';
import {
  HolidayDetailGenericPagePriceGridComponent
} from '../holiday-detail-generic-page/holiday-detail-generic-page-price-grid/holiday-detail-generic-page-price-grid.component';
import {HolidayModule} from '../holiday.module';
import {HolidayBestSolutionPipe} from '../holiday-detail-generic-page/best-solution-for-detail-query.pipe';
import {DetailContentPacketComponent} from "./components/detail-content-packet/detail-content-packet.component";

const routes: Routes = [
  {
    path: ':productId/:topId/:packetId/:pluginSource/struttura/:holidayTitle/dal/:dateFrom/al/:dateTo',
    component: HolidayDetailComponent
  },
  {
    path: ':productId/:topId/:packetId/:pluginSource/struttura/:holidayTitle/dal/:dateFrom/al/:dateTo/durata/:duration/eta/:ages',
    component: HolidayDetailComponent
  },
  //  Nuova rotta dettaglio holiday generica
  {
    path: ':productName/:productId',
    component: HolidayDetailGenericPageComponent
  }
];

@NgModule({
  declarations: [
    HolidayDetailComponent,
    DetailContentAsideComponent,
    DetailContentAccomodationComponent,
    DetailHeaderComponent,
    DetailSliderComponent,
    DetailContentTourTabsComponent,
    DetailContentTourComponent,
    DetailContentOffersComponent,
    TourCenterLatLngPipe,
    TourStopMarkersPipe,
    DetailResumeComponent,
    DetailContentAccomodationTabsComponent,
    DetailGalleryComponent,
    DetailContentTagsComponent,
    DetailContentDescriptionComponent,
    DetailContentMapComponent,
    DetailContentActivitiesComponent,
    DetailContentLanguagesComponent,
    DetailContentFacilitiesComponent,
    DetailContentTermsComponent,
    DetailContentItineraryComponent,
    DetailFlightComponent,
    DetailOccupancyComponent,
    DetailPriceGridComponent,
    HolidayDetailGenericPageComponent,
    HolidayDetailGenericPageSolutionsComponent,
    HolidayDetailGenericPageSolutionCardComponent,
    HolidayDetailGenericPageRecapComponent,
    HolidayDetailgenericPageDateComponent,
    HolidayDetailGenericPagePriceGridComponent,
    HolidayBestSolutionPipe,
    DetailContentPacketComponent
  ],
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    HolidayModule,
  ],
  exports: [
    RouterModule,
    HolidayDetailComponent,
    HolidayDetailGenericPageComponent,
    DetailHeaderComponent,
    DetailGalleryComponent,
    DetailContentAsideComponent,
    DetailContentAccomodationTabsComponent,
    DetailContentAccomodationTabsComponent,
    DetailContentAccomodationComponent
  ],
  providers: [TourStopMarkersPipe, HolidayBestSolutionPipe]
})
export class HolidayDetailPageModule {
}
